import { createStore } from "vuex";
import authModule from "./modules/auth/index.js";
import leaguesModule from "./modules/leagues/index.js";
import teamsModule from "./modules/teams/index.js";
import boardsModule from './modules/boards/index.js'
import statsModule from './modules/stats/index.js'
import notificationsModule from'./modules/notifications/index.js'

export default createStore({
	modules: {
		auth: authModule,
		leagues: leaguesModule,
		teams: teamsModule,
		boards: boardsModule,
		stats: statsModule,
		notifications: notificationsModule
	},
});
